import {tripState, tripGetters, tripMutations} from './pages/trips/store';
import {cashierGetters, cashierMutations, cashierState} from "./pages/cashier_dashboard/store";
import {langState, langMutations} from "./addStores/langStore"
import {scheduleGetters, scheduleMutations, scheduleState} from "./pages/schedule/store";

export default {
    state: {
        ...langState,
        ...scheduleState,
        auth: null,
        isAuthorized: false,
        openLeftSide: true,
        regularityTypes: [],
        trips: tripState,
        cashier: cashierState,
        screenLocked: false,
        userLastdate: +new Date(),
        userPermissions: [],
        mainLoading: true,
        loadingCnt: 0,
    },
    getters: {
        ...tripGetters,
        ...cashierGetters,
        ...scheduleGetters,
        getRegularity: state => (type) => {
            let regType = state.regularityTypes.find(item => {
                return item.index === type;
            });
            return (regType || {name: ''}).name;
        }
    },
    mutations: {
        ...tripMutations,
        ...cashierMutations,
        ...langMutations,
        ...scheduleMutations,
        loadAuth(state, auth) {
            state.auth = auth;
            state.isAuthorized = true;
        },
        logout(state, auth) {
            state.auth = null;
            state.isAuthorized = false;
        },
        loadPerms(state, perms) {
            state.userPermissions = perms;
        },
        lockScreen(state) {
            state.screenLocked = true;
            localStorage.setItem('screenLocked', 10)
        },
        unlockScreen(state) {
            state.screenLocked = false;
            state.userLastdate = +new Date();
            localStorage.setItem('screenLocked', 0);
        },
        toggleLeftMenu(state, bool) {
            state.openLeftSide = bool;
        },
        setRegularityTypes(state, data) {
            state.regularityTypes = data;
        },
        successNotify() {
            this.commit("successNotifyByText", "Сохранено!")
        },
        successRemoveNotify() {
            this.commit("successNotifyByText", "Удалено!")
        },
        successChangeNotify() {
            this.commit("successNotifyByText", "Изменено!")
        },
        successNotifyByText(state, text) {
            Vue.notify({
                type: 'success',
                group: 'foo',
                title: 'Успешно!!!',
                text: text
            });
        },
        errorNotifyByText(state, text) {
            Vue.notify({
                type: 'error',
                group: 'foo',
                title: 'Ошибка!!!',
                text: text
            });
        },
        startLoading(state) {
            state.mainLoading = true;
        },
        finishLoading(state) {
            state.mainLoading = false;
        },
    }
};
